// People Involved Dummy Data
export const peopleInvolvedDummyData = [
  {
    id: 'person-1',
    caseId: 'IA-2025-001',
    name: 'Officer Tunde Bakare',
    type: 'Officer',
    dateOfBirth: '1985-03-15',
    dataSource: 'Internal Database',
    phoneNumber: '+234 803 456 7890',
    involvement: 'Subject',
    race: 'White',
    email: 'tunde.bakare@lagospolice.gov.ng',
    address: '15 Admiralty Way, Lekki Phase 1, Lagos',
    badgeNumber: 'LP-4521',
  },
  {
    id: 'person-2',
    caseId: 'IA-2025-001',
    name: 'Mrs. Ngozi Okonkwo',
    type: 'Civilian',
    dateOfBirth: '1978-07-22',
    dataSource: 'Citizen Report',
    phoneNumber: '+234 805 123 4567',
    involvement: 'Complainant',
    race: 'Brown',
    email: 'ngozi.okonkwo@email.com',
    address: '42 Ozumba Mbadiwe Avenue, Victoria Island, Lagos',
    badgeNumber: null,
  },
  {
    id: 'person-3',
    caseId: 'IA-2025-001',
    name: 'Mr. Ibrahim Musa',
    type: 'Civilian',
    dateOfBirth: '1990-11-08',
    dataSource: 'Manual Entry',
    phoneNumber: '+234 807 890 1234',
    involvement: 'Witness',
    race: 'Chocolate',
    email: 'ibrahim.musa@email.com',
    address: '8 Falomo Road, Ikoyi, Lagos',
    badgeNumber: null,
  },
  {
    id: 'person-4',
    caseId: 'IA-2025-002',
    name: 'Constable Amaka Eze',
    type: 'Officer',
    dateOfBirth: '1992-05-30',
    dataSource: 'Internal Database',
    phoneNumber: '+234 809 234 5678',
    involvement: 'Subject',
    race: 'White',
    email: 'amaka.eze@lagospolice.gov.ng',
    address: '23 Herbert Macaulay Way, Yaba, Lagos',
    badgeNumber: 'LP-5623',
  },
  {
    id: 'person-5',
    caseId: 'IA-2025-002',
    name: 'Miss Chidinma Okoro',
    type: 'Civilian',
    dateOfBirth: '1995-09-12',
    dataSource: 'Citizen Report',
    phoneNumber: '+234 806 345 6789',
    involvement: 'Complainant',
    race: 'White',
    email: 'chidinma.okoro@email.com',
    address: '56 Allen Avenue, Ikeja, Lagos',
    badgeNumber: null,
  },
  {
    id: 'person-6',
    caseId: 'IA-2025-002',
    name: 'Inspector Sandra Kalu',
    type: 'Officer',
    dateOfBirth: '1980-02-18',
    dataSource: 'Internal Database',
    phoneNumber: '+234 808 456 7890',
    involvement: 'Investigating Officer',
    race: 'Black',
    email: 'sandra.kalu@lagospolice.gov.ng',
    address: '12 Marine Road, Apapa, Lagos',
    badgeNumber: 'LP-3456',
  },
  {
    id: 'person-7',
    caseId: 'IA-2025-003',
    name: 'Sergeant Femi Adeyemi',
    type: 'Officer',
    dateOfBirth: '1988-06-25',
    dataSource: 'Internal Database',
    phoneNumber: '+234 810 567 8901',
    involvement: 'Subject',
    race: 'Black',
    email: 'femi.adeyemi@lagospolice.gov.ng',
    address: '34 Agege Motor Road, Ikeja, Lagos',
    badgeNumber: 'LP-4789',
  },
  {
    id: 'person-8',
    caseId: 'IA-2025-003',
    name: 'Mr. Chukwuma Nnamdi',
    type: 'Civilian',
    dateOfBirth: '1975-12-03',
    dataSource: 'Manual Entry',
    phoneNumber: '+234 802 678 9012',
    involvement: 'Witness',
    race: 'Black',
    email: 'chukwuma.nnamdi@email.com',
    address: '19 Bode Thomas Street, Surulere, Lagos',
    badgeNumber: null,
  },
  {
    id: 'person-9',
    caseId: 'IA-2025-004',
    name: 'Officer Yusuf Abdullahi',
    type: 'Officer',
    dateOfBirth: '1991-04-17',
    dataSource: 'Internal Database',
    phoneNumber: '+234 811 789 0123',
    involvement: 'Subject',
    race: 'Black',
    email: 'yusuf.abdullahi@lagospolice.gov.ng',
    address: '67 Ikorodu Road, Palmgrove, Lagos',
    badgeNumber: 'LP-5234',
  },
  {
    id: 'person-10',
    caseId: 'IA-2025-005',
    name: 'Corporal Blessing Okafor',
    type: 'Officer',
    dateOfBirth: '1993-08-09',
    dataSource: 'Internal Database',
    phoneNumber: '+234 813 890 1234',
    involvement: 'Subject',
    race: 'White',
    email: 'blessing.okafor@lagospolice.gov.ng',
    address: '45 Eko Bridge, Lagos Island, Lagos',
    badgeNumber: 'LP-5678',
  },
  {
    id: 'person-11',
    caseId: 'IA-2025-005',
    name: 'Anonymous Witness 01',
    type: 'Civilian',
    dateOfBirth: null,
    dataSource: 'Citizen Report',
    phoneNumber: 'Withheld',
    involvement: 'Witness',
    race: 'Unknown',
    email: null,
    address: 'Confidential',
    badgeNumber: null,
  },
];

export const isCasesDummyData = [
  {
    id: 'IA-1',
    position: 1,
    caseId: 'IA-2025-001',
    officersWithAccess: 'Det. Ayo Bello (Lead), Sgt. Chioma Okafor',
    caseType: 'Use of Force',
    status: 'Open',
    createdBy: 'Det. Ayo Bello',
    createdAt: '2025-11-28T14:32:00Z',
    summary: 'Alleged excessive force during traffic stop at Lekki Phase 1.',
    location: 'Lekki Phase 1 checkpoint',
    source: 'Citizen complaint',
    priority: 'High',
    lastUpdated: '2025-11-29T09:15:00Z',
  },
  {
    id: 'IA-2',
    position: 2,
    caseId: 'IA-2025-002',
    officersWithAccess: 'Insp. Sandra Kalu (Lead), Sgt. Musa Idris',
    caseType: 'Harassment',
    status: 'In Progress',
    createdBy: 'Insp. Sandra Kalu',
    createdAt: '2025-11-25T10:05:00Z',
    summary:
      'Allegation of verbal harassment towards civilian at station front desk.',
    location: 'Central Station Front Desk',
    source: 'Internal report',
    priority: 'Medium',
    lastUpdated: '2025-11-28T16:40:00Z',
  },
  {
    id: 'IA-3',
    position: 3,
    caseId: 'IA-2025-003',
    officersWithAccess: 'Det. Michael Ade, IA Officer Jane Smith',
    caseType: 'Corruption',
    status: 'In Progress',
    createdBy: 'IA Officer Jane Smith',
    createdAt: '2025-11-20T08:45:00Z',
    summary: 'Suspicious cash deposits linked to traffic enforcement unit.',
    location: 'Traffic Enforcement Unit – Mainland',
    source: 'Whistleblower',
    priority: 'High',
    lastUpdated: '2025-11-22T11:10:00Z',
  },
  {
    id: 'IA-4',
    position: 4,
    caseId: 'IA-2025-004',
    officersWithAccess: 'IA Officer John Doe',
    caseType: 'Policy Violation',
    status: 'Closed',
    createdBy: 'System (Auto-flag)',
    createdAt: '2025-10-30T13:20:00Z',
    summary: 'Repeated failure to log bodycam footage after patrol.',
    location: 'Island Patrol Unit',
    source: 'System audit',
    priority: 'Medium',
    lastUpdated: '2025-11-05T09:00:00Z',
  },
  {
    id: 'IA-5',
    position: 5,
    caseId: 'IA-2025-005',
    officersWithAccess: 'IA Officer Lara Okon, Det. Ibrahim Yusuf',
    caseType: 'Conduct Unbecoming',
    status: 'Open',
    createdBy: 'IA Officer Lara Okon',
    createdAt: '2025-11-29T07:55:00Z',
    summary:
      'Video surfaced on social media showing officer using offensive language.',
    location: 'Off-duty, private residence (reported)',
    source: 'Social media monitoring',
    priority: 'High',
    lastUpdated: '2025-11-29T08:10:00Z',
  },
  {
    id: 'IA-6',
    position: 6,
    caseId: 'IA-2025-006',
    officersWithAccess: 'IA Officer John Doe, Data Officer Kemi Adeyemi',
    caseType: 'Data Privacy Breach',
    status: 'In Progress',
    createdBy: 'Data Officer Kemi Adeyemi',
    createdAt: '2025-11-18T12:12:00Z',
    summary:
      'Unauthorized export of suspect database to external storage device.',
    location: 'HQ – Records Office',
    source: 'System alert',
    priority: 'Critical',
    lastUpdated: '2025-11-21T17:45:00Z',
  },
  {
    id: 'IA-7',
    position: 7,
    caseId: 'IA-2025-007',
    officersWithAccess: 'IA Officer Jane Smith',
    caseType: 'Use of Force',
    status: 'Closed',
    createdBy: 'IA Officer Jane Smith',
    createdAt: '2025-09-05T09:00:00Z',
    summary:
      "Review of bodycam footage validated officer's use of minimum necessary force.",
    location: 'Ojota Bus Terminal',
    source: 'Routine review',
    priority: 'Low',
    lastUpdated: '2025-09-15T10:30:00Z',
  },
  {
    id: 'IA-8',
    position: 8,
    caseId: 'IA-2025-008',
    officersWithAccess: 'Det. Chika Nwosu, IA Officer John Doe',
    caseType: 'Policy Violation',
    status: 'Closed',
    createdBy: 'Det. Chika Nwosu',
    createdAt: '2025-06-10T11:40:00Z',
    summary: 'Failure to attend mandatory ethics training sessions.',
    location: 'Training & Development Unit',
    source: 'HR report',
    priority: 'Low',
    lastUpdated: '2025-07-01T14:00:00Z',
  },
  {
    id: 'IA-9',
    position: 9,
    caseId: 'IA-2025-009',
    officersWithAccess: 'IA Officer Jane Smith, Insp. Musa Idris',
    caseType: 'Harassment',
    status: 'Open',
    createdBy: 'Anonymous',
    createdAt: '2025-11-30T18:05:00Z',
    summary:
      'Anonymous tip regarding supervisor making inappropriate comments.',
    location: 'Central Station – Operations Wing',
    source: 'Anonymous hotline',
    priority: 'Medium',
    lastUpdated: '2025-12-01T09:45:00Z',
  },
  {
    id: 'IA-10',
    position: 10,
    caseId: 'IA-2025-010',
    officersWithAccess: 'IA Officer Lara Okon',
    caseType: 'Conduct Unbecoming',
    status: 'In Progress',
    createdBy: 'IA Officer Lara Okon',
    createdAt: '2025-11-10T07:20:00Z',
    summary: 'Alleged unprofessional behavior during court appearance.',
    location: 'High Court Complex',
    source: 'Judicial complaint',
    priority: 'Medium',
    lastUpdated: '2025-11-16T10:05:00Z',
  },
];

// Related Records Dummy Data
export const relatedRecordsDummyData = [
  {
    id: 'record-1',
    iaCaseId: 'IA-2025-001',
    caseNumber: 'CR-2025-4521',
    recordType: 'Criminal Case',
    agency: 'Lagos State Police - Lekki Division',
    primaryOfficer: 'Det. Ayo Bello',
    createdDate: '2025-11-28T14:30:00Z',
    status: 'Active',
    description: 'Assault complaint filed during traffic stop incident',
    location: 'Lekki Phase 1',
    relationship: 'Direct involvement - Subject of IA case was primary officer',
  },
  {
    id: 'record-2',
    iaCaseId: 'IA-2025-001',
    caseNumber: 'TR-2025-8934',
    recordType: 'Traffic Incident',
    agency: 'Lagos State Traffic Management Authority',
    primaryOfficer: 'Officer Tunde Bakare',
    createdDate: '2025-11-28T13:45:00Z',
    status: 'Closed',
    description: 'Traffic violation stop that led to use of force allegation',
    location: 'Lekki-Epe Expressway',
    relationship: 'Incident that triggered IA investigation',
  },
  {
    id: 'record-3',
    iaCaseId: 'IA-2025-001',
    caseNumber: 'CFS-2025-12456',
    recordType: 'Call for Service',
    agency: 'Lagos Emergency Response',
    primaryOfficer: 'Dispatcher M. Johnson',
    createdDate: '2025-11-28T14:15:00Z',
    status: 'Completed',
    description: 'Emergency call regarding officer conduct at traffic stop',
    location: 'Lekki Phase 1',
    relationship: 'Citizen complaint call',
  },
  {
    id: 'record-4',
    iaCaseId: 'IA-2025-002',
    caseNumber: 'IR-2025-3421',
    recordType: 'Incident Report',
    agency: 'Lagos State Police - Central Station',
    primaryOfficer: 'Sgt. Musa Idris',
    createdDate: '2025-11-25T09:30:00Z',
    status: 'Under Review',
    description: 'Verbal altercation at station front desk',
    location: 'Central Station',
    relationship: 'Original incident report',
  },
  {
    id: 'record-5',
    iaCaseId: 'IA-2025-002',
    caseNumber: 'CR-2025-4567',
    recordType: 'Criminal Case',
    agency: 'Lagos State Police - Central Station',
    primaryOfficer: 'Insp. Sandra Kalu',
    createdDate: '2025-11-24T16:20:00Z',
    status: 'Active',
    description: 'Disorderly conduct complaint filed by civilian',
    location: 'Central Station',
    relationship: 'Related complaint against same officer',
  },
  {
    id: 'record-6',
    iaCaseId: 'IA-2025-003',
    caseNumber: 'AR-2025-7832',
    recordType: 'Arrest Report',
    agency: 'Lagos State Police - Traffic Unit',
    primaryOfficer: 'Sgt. Femi Adeyemi',
    createdDate: '2025-11-19T11:45:00Z',
    status: 'Closed',
    description: 'Multiple arrests with inconsistent documentation',
    location: 'Traffic Enforcement Unit',
    relationship: 'Pattern of suspicious activity',
  },
  {
    id: 'record-7',
    iaCaseId: 'IA-2025-003',
    caseNumber: 'PR-2025-2341',
    recordType: 'Property Report',
    agency: 'Lagos State Police - Evidence Unit',
    primaryOfficer: 'Det. Michael Ade',
    createdDate: '2025-11-20T08:30:00Z',
    status: 'Under Investigation',
    description: 'Cash and valuables seized during traffic stops',
    location: 'Evidence Storage',
    relationship: 'Evidence related to corruption investigation',
  },
  {
    id: 'record-8',
    iaCaseId: 'IA-2025-004',
    caseNumber: 'IR-2025-5623',
    recordType: 'Incident Report',
    agency: 'Lagos State Police - Island Patrol',
    primaryOfficer: 'Officer Yusuf Abdullahi',
    createdDate: '2025-10-29T15:30:00Z',
    status: 'Closed',
    description: 'Patrol incident with missing bodycam footage',
    location: 'Victoria Island',
    relationship: 'First instance of policy violation',
  },
  {
    id: 'record-9',
    iaCaseId: 'IA-2025-005',
    caseNumber: 'CR-2025-8901',
    recordType: 'Criminal Case',
    agency: 'Lagos State Police - Social Media Unit',
    primaryOfficer: 'IA Officer Lara Okon',
    createdDate: '2025-11-29T07:45:00Z',
    status: 'Active',
    description: 'Public complaint based on viral video',
    location: 'Online/Social Media',
    relationship: 'Source of IA investigation',
  },
  {
    id: 'record-10',
    iaCaseId: 'IA-2025-005',
    caseNumber: 'IR-2025-6734',
    recordType: 'Incident Report',
    agency: 'Lagos State Police - Community Relations',
    primaryOfficer: 'Det. Ibrahim Yusuf',
    createdDate: '2025-11-28T18:30:00Z',
    status: 'Under Review',
    description: 'Community complaints about officer behavior',
    location: 'Ikeja Community',
    relationship: 'Supporting evidence of pattern',
  },
  {
    id: 'record-11',
    iaCaseId: 'IA-2025-006',
    caseNumber: 'PR-2025-4512',
    recordType: 'Property Report',
    agency: 'Lagos State Police - Records Office',
    primaryOfficer: 'Data Officer Kemi Adeyemi',
    createdDate: '2025-11-18T11:50:00Z',
    status: 'Active',
    description: 'Unauthorized database access and data export',
    location: 'HQ Records Office',
    relationship: 'Core evidence in data breach case',
  },
  {
    id: 'record-12',
    iaCaseId: 'IA-2025-009',
    caseNumber: 'CFS-2025-15678',
    recordType: 'Call for Service',
    agency: 'Anonymous Hotline Service',
    primaryOfficer: 'Anonymous',
    createdDate: '2025-11-30T17:55:00Z',
    status: 'Active',
    description: 'Anonymous tip regarding workplace harassment',
    location: 'Central Station',
    relationship: 'Initial report that triggered investigation',
  },
];

// Audit Trail Dummy Data
export const auditTrailDummyData = [
  {
    id: 'audit-1',
    iaCaseId: 'IA-2025-001',
    createdAt: '2025-11-28T14:32:00Z',
    event: 'Create',
    field: 'Case',
    value: 'IA-2025-001 - Use of Force case created',
    changedBy: 'Det. Ayo Bello',
    triggeredBy: 'Manual creation',
    metadata: {
      caseType: 'Use of Force',
      priority: 'High',
    },
  },
  {
    id: 'audit-2',
    iaCaseId: 'IA-2025-001',
    createdAt: '2025-11-28T14:35:00Z',
    event: 'Edit',
    field: 'Summary',
    value: 'Alleged excessive force during traffic stop at Lekki Phase 1',
    changedBy: 'Det. Ayo Bello',
    triggeredBy: 'Case update',
    metadata: {
      previousValue: '',
      newValue: 'Alleged excessive force during traffic stop at Lekki Phase 1',
    },
  },
  {
    id: 'audit-3',
    iaCaseId: 'IA-2025-001',
    createdAt: '2025-11-28T14:40:00Z',
    event: 'Permission grants',
    field: 'Access',
    value: 'Granted access to Sgt. Chioma Okafor',
    changedBy: 'Det. Ayo Bello',
    triggeredBy: 'Permission update',
    metadata: {
      grantedTo: 'Sgt. Chioma Okafor',
      role: 'Investigator',
    },
  },
  {
    id: 'audit-4',
    iaCaseId: 'IA-2025-001',
    createdAt: '2025-11-28T15:10:00Z',
    event: 'File upload',
    field: 'Evidence',
    value: 'bodycam_footage_lekki_112825.mp4',
    changedBy: 'Sgt. Chioma Okafor',
    triggeredBy: 'Evidence submission',
    metadata: {
      fileName: 'bodycam_footage_lekki_112825.mp4',
      fileSize: '245.3 MB',
    },
  },
  {
    id: 'audit-5',
    iaCaseId: 'IA-2025-001',
    createdAt: '2025-11-29T09:15:00Z',
    event: 'Status changes',
    field: 'Status',
    value: 'Changed from "Open" to "In Progress"',
    changedBy: 'Det. Ayo Bello',
    triggeredBy: 'Investigation commenced',
    metadata: {
      previousStatus: 'Open',
      newStatus: 'In Progress',
    },
  },
  {
    id: 'audit-6',
    iaCaseId: 'IA-2025-002',
    createdAt: '2025-11-25T10:05:00Z',
    event: 'Create',
    field: 'Case',
    value: 'IA-2025-002 - Harassment case created',
    changedBy: 'Insp. Sandra Kalu',
    triggeredBy: 'Internal report',
    metadata: {
      caseType: 'Harassment',
      priority: 'Medium',
    },
  },
  {
    id: 'audit-7',
    iaCaseId: 'IA-2025-002',
    createdAt: '2025-11-25T10:30:00Z',
    event: 'Assignment change',
    field: 'Investigator',
    value: 'Assigned to Sgt. Musa Idris',
    changedBy: 'Insp. Sandra Kalu',
    triggeredBy: 'Case assignment',
    metadata: {
      assignedTo: 'Sgt. Musa Idris',
    },
  },
  {
    id: 'audit-8',
    iaCaseId: 'IA-2025-002',
    createdAt: '2025-11-26T14:20:00Z',
    event: 'Comment added',
    field: 'Notes',
    value: 'Interviewed complainant. Reviewing station CCTV footage.',
    changedBy: 'Sgt. Musa Idris',
    triggeredBy: 'Investigation update',
    metadata: {
      commentLength: 57,
    },
  },
  {
    id: 'audit-9',
    iaCaseId: 'IA-2025-002',
    createdAt: '2025-11-28T16:40:00Z',
    event: 'File upload',
    field: 'Evidence',
    value: 'witness_statement_okonkwo.pdf',
    changedBy: 'Sgt. Musa Idris',
    triggeredBy: 'Evidence submission',
    metadata: {
      fileName: 'witness_statement_okonkwo.pdf',
      fileSize: '1.2 MB',
    },
  },
  {
    id: 'audit-10',
    iaCaseId: 'IA-2025-003',
    createdAt: '2025-11-20T08:45:00Z',
    event: 'Create',
    field: 'Case',
    value: 'IA-2025-003 - Corruption case created',
    changedBy: 'IA Officer Jane Smith',
    triggeredBy: 'Whistleblower report',
    metadata: {
      caseType: 'Corruption',
      priority: 'High',
    },
  },
];
